import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PersonnalisationPage from "@/pages/PersonnalisationPage";
import ConfirmationDemande from "@/pages/ConfirmationDemande";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/paiement-succes" element={<PaymentSuccess />} />
          <Route path="/personnalisation" element={<PersonnalisationPage />} />
          <Route path="/confirmation-demande" element={<ConfirmationDemande />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
